// extracted by mini-css-extract-plugin
module.exports = {"columnWidth":"BrokerOfferSell_columnWidth__1a1Gg","container":"BrokerOfferSell_container__39LQe"};